export class PromocionProcesada {
    public PrecioTotal: number; //Precio incluyendo las promociones
    public PrecioTotalPromocion: number;
    public ValorTotalMonedero: number = 0;
    public ListPromocionesAsociadas = new Array<PromocionesAsociadas>();
}

export class PromocionesAsociadas {
    public IDPromocion: number;
    public Nombre;
    public Valor;
    public ValorPorcentaje = 0;
    public ListObsSKU = new Array<any>();
    public PromocionCombinada: PromocionCombinada = null;
    public ValorMonedero: number = 0;
    public IdCupon: string = null;
    public Regla: string;
    public Aplicada: boolean;
    public Tipo: string;
    public ReglaObseq: string;
    public CantidadObseq: number;
    public flags = { formaPago: false };
}

export class PromocionCombinada {
    public IdPromocionXProceso: number;
    public IdPromocionCombinada: number;
    public Tipo2: string;
    public Nombre: string;
    public Accion: any;
    //public IdCondicion:string; //Esto para agrupacion de la promocion de combo.
}